import React from 'react'
import S from 'string'

/**
 * Replace placeholders in the given string. Use %<index in values> to recognize the replacement target.
 * E.g.: replacePlaceholders("Hello, %0! Welcome to %1!", "Markus", "St.Pete") => "Hello, Markus! Welcome to St.Pete!"
 * @param message the message to update
 * @param values vararg with strings/objects with toString() to fill placeholders
 */
export function replacePlaceholders(message, ...values) {
    let result = S(message);
    values.forEach((value, i) => {
        result = result.replaceAll('%'+i, value);
    });
    return result.s;
}

/**
 * Replace placeholders in the given string. Use % to recognize the replacement target.
 * E.g.: replaceJsxPlaceholders("Hello, %! Welcome to %!", <span>Markus</span>, <div>St.Pete</div>)
 * => Hello, <span>Markus</span>! Welcome to <div>St.Pete</div>!
 * @param message the message to update
 * @param values vararg with JSX to fill placeholders
 */
export function replaceJsxPlaceholders(message, ...values) {
    let splittedMessage = message.split('%');
    return (
        <span>
        {splittedMessage.map((part, i) => (
            <span key={i}>{part}{values[i] || null}</span>
        ))}
        </span>
    );
}

/**
 * Replaces \n symbols in the given string with <br/> tag.
 * @param message the message to update
 */
export function replaceLineEnds(message) {
    let splittedMessage = message.split('\n');
    return (
        <span>
        {splittedMessage.map((part, i) => (
            <span key={i}>{part}<br/></span>
        ))}
        </span>
    );
}


// WEBPACK FOOTER //
// ./src/common/Replace.js